// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
// eslint-disable-next-line import/named
import {
  createRoute,
  lazyRouteComponent,
  redirect,
} from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";

import PendingComponent from "../../components/PendingComponent";
import { isMeaningfulGigsRole } from "../../utils/auth";
import { ASK_V2_HOME_PATH } from "../paths";

export const askV2StyleGuideRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt/style-guide",
  beforeLoad() {
    if (!isMeaningfulGigsRole()) {
      throw redirect({ to: ASK_V2_HOME_PATH });
    }
  },
  // why: barrel under components/ so V2 can lazy-load the catalog without a routes/ask-puntt import
  component: lazyRouteComponent(
    () => import("../../components/ask-puntt-style-guide"),
  ),
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: false,
  pendingMs: 0,
  pendingMinMs: 500,
});
